import {
  CarrierAndreani,
  CarrierCorreoArgentino,
  CarrierEnvia,
  CarrierEPick
} from '../freight-type';

export const MISSING_TAX_INFORMATION_ERROR =
  'dispatch-gw.error.missing-tax-information';

export const JET_CPF_SENDER_ERROR = 'dispatch-gw.error.jet.cpf-sender';

export const FILE_GENERATION_ERROR = 'app-back.unexpected-error.generate-file';

export const INVALID_AGENCY_ERROR = 'dispatch-gw.error.invalid-agency';

export const MISSING_FISCAL_INFORMATION_DOCUMENT_ERROR =
  'dispatch-gw.error.invalid-or-missing-fiscal-document-key';

export const DCE_INELEGIBLE_MERCHANT =
  'dispatch-gw.error.correios-dce-ineligible-merchant';

export const DCE_NOT_ALLOWED_INTERSTATE_ROUTE_ERROR =
  'dispatch-gw.error.content-declaration-not-allowed-interstate-route';

export const DCE_NOT_ALLOWED_FISCAL_DOCUMENT_ERROR =
  'order.error.fiscal-document-dce-restricted-interstate';

export const CANNOT_PRINT_CONTENT_DECLARATION_NO_DCE_ERROR =
  'dispatch-gw.error.content-declaration-cannot-print-no-dce';

export const UNMAPPED_CORREIOS_ERROR =
  'dispatch-gw.error.correios-ppn.unmapped';

export const INSUFFICIENT_BALANCE_ERROR =
  'dispatch-gw.error.insufficient-balance-error';

export const DISPATCH_LIMIT_PER_DAY_ERROR =
  'dispatch-gw.error.limit-of-dispatch-per-day';

export const MISSING_STATE_REGISTRATION_ERROR =
  'dispatch-gw.error.order-is-missing-state-registration';

export const ALREADY_IN_PROCESSING_ERROR =
  'dispatch-gw.error.order-already-in-processing';

export const MARK_ORDER_AS_SENT_ERROR =
  'order.error.update-order-without-tracking-code';

export const DISPATCHER_ERROR = 'dispatch-gw.error.unexpected-dispatcher-error';

export const CORREIOS_DCE_POLLING_EXHAUSTED_ERROR =
  'dispatch-gw.error.correios-dce-polling-exhausted';

export const CARRIER_WITH_PASS_THROUGH_ERRORS = [
  CarrierCorreoArgentino,
  CarrierEnvia,
  CarrierAndreani,
  CarrierEPick
];
